module.exports = __webpack_public_path__ + "static/media/15b-03_Serie-blanca-3-2015-200x300cm-oleo-sobre-papel.68c39493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15b/15b-03_Serie-blanca-3-2015-200x300cm-oleo-sobre-papel.jpg
// module id = 160
// module chunks = 0